<div class="risk-generate-ai-workspace">
    <cerrix-header
    [title]="title"
    [subTitle]="subtitle"
    ></cerrix-header>
        @if (data && data.length > 0) {
            <cerrix-filtered-generic-list-manager
            [config]="config"
            (addButtonClicked)="openAddPopup()"
            ></cerrix-filtered-generic-list-manager>
        }
</div>
<generate-ai-risks-dialog
[name]="dialogName"
[showGoBack]="false"
></generate-ai-risks-dialog>

